<template>
  <div id="condition">
    <div class="plan-condition pt-2 bg-light_gray border-b border-section_border">
      <h2 class="section-title mb-2 px-4 text-center text-lg">
        {{ $t('plan_create_title') }}
      </h2>
      <div id="conditionVisible" v-if="showCondition">
        <div class="mb-4 px-4">
          <p class="condition-label text-label">{{ $t('departure_date_condition') }}</p>
          <input type="date" v-model="date" class="text-link_darker is-condition">
        </div>
        <div class="condition-detail py-2 border-t border-b border-section_border">
          <p
            class="btn-condition-open text-center text-link_darker"
            v-on:click="toggle"
            v-bind:class="{ 'is-condition-open' : isOpen }">
            {{ $t('detail_conditions') }}
          </p>
          <div v-show=isOpen class="condition-detail-contents px-4">
            <div class="mb-4">
              <p class="condition-label text-label">{{ $t('preferred_route_condition') }}</p>
              <select v-model="sort" class="is-condition">
                <option v-for="(option, key) in sortOptions" v-bind:value="option.value" v-bind:key="key">
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="mb-4">
              <p class="condition-label text-label">{{ $t('taxi_condition') }}</p>
              <select v-model="taxiDistance" class="is-condition">
                <option v-for="(option, key) in taxiOptions" v-bind:value="option.value" v-bind:key="key">
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="mt-6 px-4">
          <a @click="handleClick" class="button-primary block">{{ $t('set_conditions_label') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      taxiOptions: [
        { text: this.$t('taxi_distance_none'), value: 0 },
        { text: this.$t('taxi_distance_1km'), value: 1000 },
        { text: this.$t('taxi_distance_3km'), value: 3000 }
      ],
      sortOptions: [
        { text: this.$t('preferred_route_condition_free_pass'), value: "freePass" },
        { text: this.$t('preferred_route_condition_ekispert'), value: "ekispert" }
      ],
      isOpen: false,
      showCondition: false
    }
  },
  computed: {
    date: {
      get () {
        const date = this.$store.getters['condition/getTime']
        return date.format('YYYY-MM-DD')
      },
      set (value) {
        let datetime = moment({hour: 10})
        if (value) {
          datetime = moment(value).set('hour', 10)
        }
        this.$store.dispatch('condition/updateOptions', { time: datetime })
      }
    },
    taxiDistance: {
      get () {
        return this.$store.getters['condition/getTaxiDistance']
      },
      set (value) {
        this.$store.dispatch('condition/updateOptions', { taxiDistance: value })
      }
    },
    sort: {
      get () {
        return this.$store.getters['condition/getSort']
      },
      set (value) {
        this.$store.dispatch('condition/updateOptions', { sort: value })
      }
    }
  },
  methods: {
    handleClick: function () {
      this.$store.dispatch('routes/search')
    },
    toggle: function () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>
